import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
const axiosInstance = axios.create()

// 3.响应拦截器
axiosInstance.interceptors.response.use(response => {
  console.log(response.data)
  if (response.data.code === 0) {
    return response.data.result
  }
  throw response.data
}, error => {
   throw  {'code': -1, 'message': '请检查您的网络连接'}
})
//4.导入文件
export default axiosInstance



// WEBPACK FOOTER //
// ./src/utils/request.js